// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"fc94783d","409":"731f2369"}[chunkId] + ".chunk.js";
};